export const mainBox = {
  height: '60vh',
  gap: '40px',
  display: 'flex',
}

export const modalColumnHeadingBox = {
  display: 'flex',
  width: '28vw',
  flexDirection: 'column',
  gap: '15px',
}

export const stackStyle = {
  gap: '15px',
  paddingTop: '5px',
}

export const userDetailsBox = {
  display: 'flex',
  flexDirection: 'column',
  height: '300px',
  overflow: 'auto',
  gap: '15px',
  paddingTop: '5px',
}
export const innerBox = {
  display: 'flex',
  flexDirection: 'column',
  gap: '15px',
}

export const dividerStyle = {
  bgcolor: '#111',
}
